import { render } from "./ArticlesOverview.vue?vue&type=template&id=4adf9c3d"
import script from "./ArticlesOverview.vue?vue&type=script&lang=js"
export * from "./ArticlesOverview.vue?vue&type=script&lang=js"

import "./ArticlesOverview.vue?vue&type=style&index=0&id=4adf9c3d&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/ArticlesOverview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4adf9c3d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4adf9c3d', __exports__)) {
    api.reload('4adf9c3d', __exports__)
  }
  
  module.hot.accept("./ArticlesOverview.vue?vue&type=template&id=4adf9c3d", () => {
    api.rerender('4adf9c3d', render)
  })

}


export default __exports__